import { router } from "expo-router"
import { View } from "react-native"
import { Alert } from "components/ui/confirm"

import { trpc } from "utils/trpc"
import { setToken } from "utils/storage"
import { analytics } from "utils/analytics"
import { ar } from "i18n/ar"
import { Controller, useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { loginInput } from "@white-labels/input/src/m5azen"
import { Button, Text, TextInput } from "components/core"
import { SafeAreaView } from "react-native-safe-area-context"

export default function Login() {
  const utils = trpc.useUtils()
  const login = trpc.auth.login.useMutation()

  const { control, handleSubmit, formState } = useForm({
    resolver: zodResolver(loginInput),
  })
  const { isValid } = formState
  const loading = login.isPending
  const disabled = !isValid || loading

  const submit = handleSubmit(async (data) => {
    try {
      const { token, ...user } = await login.mutateAsync({ username: data.username, password: data.password })
      utils.auth.get.setData(undefined, user)
      setToken(token)
      analytics.logEvent({ name: "login", params: { method: "password", success: true } })
      router.replace("/dashboard")
    } catch {
      analytics.logEvent({ name: "login", params: { method: "password", success: false } })
      Alert.alert("Login failed", "Invalid credentials")
    }
  })

  return (
    <View className="flex-1 bg-gray-50">
      <SafeAreaView />
      <View className="px-3 justify-center w-full max-w-content mx-auto">
        <View className="mb-4 md:mb-6">
          <Text className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-2">{ar.welcome}</Text>
          <Text className="text-gray-600 text-center text-base">{ar.login}</Text>
        </View>

        <Text className="font-bold text-gray-700 mb-2 text-left text-sm">{ar.username}</Text>
        <Controller
          control={control}
          name="username"
          render={({ field }) => (
            <TextInput
              className="mb-4"
              placeholder={ar.username}
              keyboardType="email-address"
              autoCapitalize="none"
              value={field.value}
              onChangeText={field.onChange}
              onSubmitEditing={submit}
              returnKeyType="next"
            />
          )}
        />

        <Text className="font-bold text-gray-700 mb-2 text-left text-sm">{ar.password}</Text>
        <Controller
          control={control}
          name="password"
          render={({ field }) => (
            <TextInput
              className="mb-4"
              placeholder={ar.password}
              secureTextEntry
              value={field.value}
              onChangeText={field.onChange}
              onSubmitEditing={submit}
              returnKeyType="done"
            />
          )}
        />

        <Button loading={loading} disabled={disabled} onPress={submit}>
          {ar.login}
        </Button>
      </View>
    </View>
  )
}
